/* eslint formatjs/no-literal-string-in-jsx: "error" */
import { RoundedRectangle } from "../../../views/atoms/roundedrectangle/RoundedRectangle"
import { FlexContainer, H3, Stack } from "@carrotfertility/carotene"
import { Link } from "@carrotfertility/carotene-core"
import { CircleImage } from "../../../views/atoms/images/CircleImage"
import React from "react"
import { FormattedMessage } from "react-intl"

import styled from "styled-components"

const ModuleListItem = styled.li({
  fontSize: 14,
  lineHeight: 1.5,
  "&::before": {
    color: "black"
  }
})

export const DoulaRequirementsCard = (): JSX.Element => {
  return (
    <>
      <RoundedRectangle backgroundColor="light-gray" className="flex-row">
        <FlexContainer shrink={0}>
          <CircleImage iconName="icn-documents" backgroundColor={"black-10"} />
        </FlexContainer>
        <Stack direction="column" spacing="tiny" justifyContent="flex-end" paddingLeftRight="small">
          <H3 color={"black-80"}>
            <FormattedMessage defaultMessage="Doula Requirements" />
          </H3>
          <ul>
            <ModuleListItem>
              <FormattedMessage
                defaultMessage="Your doula needs to complete an <link>attestation form</link> to confirm that they meet our qualifications."
                values={{
                  link: (linkContent) => (
                    <Link
                      fontSize="inherit"
                      target="_blank"
                      href={"/your-benefit-guide/coverage/pregnancy-and-postpartum"}
                      color="inherit"
                    >
                      {linkContent}
                    </Link>
                  )
                }}
              />
            </ModuleListItem>
            <ModuleListItem>
              <FormattedMessage
                defaultMessage="Check your <link>benefit guide</link> for a list of eligible services."
                values={{
                  link: (linkContent) => (
                    <Link
                      fontSize="inherit"
                      target="_blank"
                      href={"/your-benefit-guide/coverage/pregnancy-and-postpartum"}
                      color="inherit"
                    >
                      {linkContent}
                    </Link>
                  )
                }}
              />
            </ModuleListItem>
          </ul>
        </Stack>
      </RoundedRectangle>
    </>
  )
}
